module.exports = __webpack_public_path__ + "static/media/stars-4.ac274872.svg";